export const DateTimeFormat = "MM/DD/YYYY HH:mm:ss";
export const DateTimeWebFormat = "MM/DD/YYYY HH:mm:ss.SSS A";
export const DateTimeWebFormatShort = "MM/DD/YYYY hh:mm A";
export const MomentDefaultFormat = "YYYY-MM-DDTHH:mm:ss";
export const MomentDefaultFormatTimezone = "YYYY-MM-DDTHH:mm:ssZ";
export const DateFormat = "MM/DD/YYYY";
export const TimeFormat = "hh:mm A";
export const MESSAGE_CONFIRM_LOG_OUT = "Are you sure you want to log out?";
export const LOADING_MESSAGE = 'Loading... Please Wait'
export const VisitHistory_Offline = "Visit History is only available if there is internet connection."
export const OFFLINE = "You are offline"
export const PAGE_AVAILABLE_ONLY_ONLINE= "This page is only available while online."
export const SYNCING = "Syncing... Please Wait"
export const NOTE_TOO_LONG= "Note is too long. Please add a maximum of 512 characters! ";